import Pane from './Pane';
import SplitPane from './SplitPane';

export default SplitPane;
export { Pane };
